import { createApiSlice } from "@common";
import { CRUD_RESPONSE_STATUS } from "@routes";

const apiConfig = [
  {
    name: "addResponseStatus",
    method: "post",
    url: CRUD_RESPONSE_STATUS,
    stateKey: "message",
  },
  {
    name: "getResponseStatus",
    method: "get",
    url: CRUD_RESPONSE_STATUS,
    stateKey: "data",
  },
  {
    name: "updateResponseStatus",
    method: "put",
    url: CRUD_RESPONSE_STATUS,
    stateKey: "message",
  },
  {
    name: "deleteResponseStatus",
    method: "delete",
    url: CRUD_RESPONSE_STATUS,
    stateKey: "message",
  },
];

const customReducers = {
  initialState: {
    data: [],
    additionalData: [],
  },
  reducers: {
    setAdditionalData: (state, action) => {
      state.additionalData = action.payload;
    },
  },
  extraReducers: {},
};

const { slice, thunks, actions } = createApiSlice("responseStatus", apiConfig, customReducers);
const responseStatusSlice = slice;

export default responseStatusSlice.reducer;

export const {
  addResponseStatus,
  getResponseStatus,
  updateResponseStatus,
  deleteResponseStatus,
} = thunks;

export const { rowSelect } = actions;
